<template>
  <div class="wg-row">
    <div class="com-anm22-page-title" style="font-size:24px;">
      {{ $anm22.strLang(lang, 'User settings', 'Impostazioni utente') }}
    </div>
    <!-- homepage -->
    <div class="wg-row">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'Homepage', 'Homepage') }}
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <select class="com-anm22-app-select" v-model="homepage">
        <option value="1">
          {{ $anm22.strLang(lang, 'Orders list', 'Lista ordini') }}
        </option>
        <option v-if="license.config.modules.tables.enabled" value="2">
          {{ $anm22.strLang(lang, 'Tables list', 'Lista tavoli') }}
        </option>
        <option value="3">
          {{ $anm22.strLang(lang, 'Register', 'Cassa rapida') }}
        </option>
      </select>  
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Save', 'Salva')" 
          @click="save">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: String,
  },
  data() {
    return {
      homepage: this.$anm22.getCookie('com_anm22_food_fav_index') || '3'
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    }
  },
  methods: {
    save() {
      // Update cookies
      setCookie('com_anm22_food_fav_index', this.homepage, 86400*366*2);
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
</style>
